module.exports = __webpack_public_path__ + "media/customizations/regencyatsrr/logo-701bbb3c52db77a48aac62189c9178ed.png";